var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMorthySmithHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29410",
    "data-name": "Group 29410",
    transform: "translate(-87 -422.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(87 422.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29407",
    "data-name": "Group 29407",
    transform: "translate(104 428.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50219",
    "data-name": "Path 50219",
    d: "M13.721,3A9.722,9.722,0,1,1,4,12.722C4,9.805,5.458,8.833,5.458,8.833,6.43,4.458,9.729,3,13.721,3Z",
    transform: "translate(-4 -3)",
    fill: "#6d4c41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50220",
    "data-name": "Path 50220",
    d: "M21.283,28a2.187,2.187,0,1,0,2.187,2.187A2.187,2.187,0,0,0,21.283,28Zm-14.1,0a2.187,2.187,0,1,0,2.187,2.187A2.187,2.187,0,0,0,7.187,28Z",
    transform: "translate(-4.514 -15.848)",
    fill: "#ffd391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50221",
    "data-name": "Path 50221",
    d: "M15.263,12a8.263,8.263,0,1,0,8.263,8.263A8.263,8.263,0,0,0,15.263,12Z",
    transform: "translate(-5.542 -7.625)",
    fill: "#ffd391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50222",
    "data-name": "Path 50222",
    d: "M23.857,39.179a2.141,2.141,0,0,0-3.825,0,.577.577,0,0,0,.552.765c.389,0,.583-.486,1.361-.486s.972.486,1.361.486a.577.577,0,0,0,.552-.765Z",
    transform: "translate(-12.223 -20.987)",
    fill: "#bf360c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50223",
    "data-name": "Path 50223",
    d: "M23.19,33.19a.962.962,0,0,1-1.371,0l-.729-.729,1.371-1.371.729.729A.96.96,0,0,1,23.19,33.19Z",
    transform: "translate(-12.783 -17.436)",
    fill: "#fcf5ea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28955",
    "data-name": "Group 28955",
    transform: "translate(2.917 9.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50224",
    "data-name": "Path 50224",
    d: "M20.694,22a2.916,2.916,0,1,0,2.916,2.916A2.916,2.916,0,0,0,20.694,22Zm-7.777,0a2.916,2.916,0,1,0,2.916,2.916A2.916,2.916,0,0,0,12.916,22Z",
    transform: "translate(-10 -22)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28956",
    "data-name": "Group 28956",
    transform: "translate(5.347 12.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50225",
    "data-name": "Path 50225",
    d: "M23.263,28a.486.486,0,1,0,.486.486A.486.486,0,0,0,23.263,28Zm-7.777,0a.486.486,0,1,0,.486.486A.486.486,0,0,0,15.486,28Z",
    transform: "translate(-15 -28)",
    fill: "#212121"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorthySmithHighlighted);
export default __webpack_public_path__ + "static/media/morthySmithHighlighted.a640f78924988e9cf16e04b10ffac40e.svg";
export { ForwardRef as ReactComponent };